import React from "react";
import { observer } from "mobx-react";
import AddDeviceToSubuserComponent from "./Add-device-to-subuser.component";
import useAddDeviceToSubuser from "./useAddDeviceToSubuser";
import { ICloseEvent } from "@core/interfaces/ICloseEvent";

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { subusers, groups, devices, lang, handlers, values } = useAddDeviceToSubuser(onClose);

    return (
        <>
            <AddDeviceToSubuserComponent
                lang={lang.lang}
                selectedSubuser={subusers.selectedSubuser}
                devicesList={values.devicesList}
                serverError={subusers.serverError}
                loading={subusers.addDeviceLoading || subusers.loading || devices.loading || groups.loading}
                onStateChange={handlers.handleStateChange}
                onAddClick={handlers.handleAddClick}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onSelectKeyDown={handlers.handleSelectKeyDown}
                onCancelClick={onClose}
            />
        </>
    );
};

const AddDeviceToSubuserContainer = observer(Container);

export default AddDeviceToSubuserContainer;
